import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';

const INPUT_IDENTIFIER_TO_FIELD: Record<string, string> = {
	Username: 'username',
	Email: 'email',
	OrganisationId: 'organisationId',
	BranchId: 'branchId',
};

export function useServerStockAccountValidation<T>(
	accountMutation: UseMutationResult<
		// biome-ignore lint/suspicious/noExplicitAny: <explanation>
		ApiResponse<any>,
		unknown,
		void,
		unknown
	>,
	form: UseFormReturnType<T, (values: T) => T>,
) {
	useEffect(() => {
		if (!accountMutation.data?.isValid) {
			// biome-ignore lint/complexity/noForEach: <explanation>
			accountMutation.data?.validationMessages.forEach((v) => {
				const field = INPUT_IDENTIFIER_TO_FIELD[v.inputIdentifier];

				if (field) {
					form.setFieldError(field, v.validationMessage);
				}
			});
		}
	}, [accountMutation.data?.validationMessages]);
}
